import server from '@/api/relatorio_java/serveRelatorio'
import {getAPIbaseURL} from "@/api/config/init";

export function openRelatorioJava(filename, name) {
    const url = `${getAPIbaseURL()}/download.php?tipo=3&file=${filename}&name=${name}`;
    window.open(url, '_blank');
    return url;
}

export function relNotasFiscais(data) {
    return server({
        url: `/notas_fiscais`,
        method: 'post',
        data
    })
}

export function relDuams(data) {
    return server({
        url: `/duams`,
        method: 'post',
        data
    })
}
